import React from "react";
import { InfoPageWrapper } from "../ui/InfoPageWrapper";
import { TableTermsContent } from "../components/tableTermsContent";
import { TermsIntro } from "../components/termsIntro";
import { TableOfContentsTerms } from "../components/tableOfContentsTerms";
import { useTranslation } from "react-i18next";
const TermsOfService = () => {
  const { t } = useTranslation();
  return (
    <InfoPageWrapper>
      <div className="font-sans flex flex-col text-primary-700 gap-6-res">
        <div className="gap-5 flex flex-col">
          <h1 className=" text-[26px] md:text-[28px] font-600 uppercase">
            {String(t("termsPage.title"))}
          </h1>
          <div className="flex flex-col gap-5">
            <p className="font-600  text-[16px] md:text-[18px]">
              {String(t("termsPage.date"))}
            </p>
          </div>
          <div className="text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
            <h2 className="text-[18px] md:text-[20px] font-600 my-[20px]">
              {String(t("termsPage.title"))}
            </h2>
            <TermsIntro />
          </div>
          <TableOfContentsTerms />
          <TableTermsContent />
        </div>
      </div>
    </InfoPageWrapper>
  );
};

export default TermsOfService;
